<template>
  <div class="as-statistics" :class="{
    'as-scrolling as-scrolling__have-tab as-scrolling__result-popup': !isHomePage,
    'as-home-scrollable-content': isHomePage,
  }">
    <div class="as-statistics__content">
      <div class="as-statistics__line" v-for="(stat, key) in processedStats" :key="key">
        <span class="as-statistics__value as-statistics__value--home" :class="stat.winHome">{{ stat.home }}</span>
        <span class="as-statistics__bar-wrapper as-statistics__bar-wrapper--home" :class="stat.winHome">
          <span class="as-statistics__bar as-statistics__bar--home" :style="{ width: stat.showHomePre || 50 }"></span>
        </span>
        <span class="as-statistics__title">{{ stat.type }}</span>
        <span class="as-statistics__bar-wrapper as-statistics__bar-wrapper--away" :class="stat.winAway">
          <span class="as-statistics__bar as-statistics__bar--away" :style="{ width: stat.showAwayPre || 40 }"></span>
        </span>
        <span class="as-statistics__value as-statistics__value--away" :class="stat.winAway">{{ stat.away }}</span>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, defineProps, PropType, inject, ref, watch } from "vue";
import type { IStatistics, IMatch } from "~src/interfaces/basketball";
import { getProcessedStats } from "~src/helpers/basketball/index";

interface IProps {
  statistics: IStatistics;
  // statisticAll: IStatistics;
  match: IMatch;
  isHomePage: boolean;
  isDefault: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isHomePage: false,
  isDefault: false,
});

interface IProcessedStat {
  type?: string;
  home?: string | number;
  away?: string | number;
  showHomePre?: string;
  showAwayPre?: string;
  winHome?: string;
  winAway?: string;
}

const processedStats = computed<IProcessedStat[]>(() => {
  const data = getProcessedStats(props.match, props.statistics, props.isDefault);
  if (data[0].key !== 'points') {
    return [];
  }
  return data;
});
</script>

<script lang="ts">
export default {};
</script>
